import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useAuthStore } from 'stores/authStore'
// import { useModal } from 'context/ModalContext'
import { useApi } from 'hooks/useApi'
import { useFilterState } from 'hooks/useFilterState'

import Field from 'components/Field'
import Password from 'components/Password'
import Button from 'components/Button'
// import Reference from 'components/Reference'
// import Recovery from 'modules/Modals/Recovery'

import style from './index.module.scss'

const Login = ({ isRedirect = true }) => {
  const { t } = useTranslation()
  // const { openModal } = useModal()
  const { setAuth } = useAuthStore()
  const { request } = useApi()
  const { filter, handlePropsChange } = useFilterState({
    username: '',
    password: ''
  })

  const handleSubmit = async (e) => {
    e && e.preventDefault()

    const formData = new FormData()
    formData.append('username', filter.username)
    formData.append('password', filter.password)

    const { data, error} = await request('POST', 'login/', formData, { isWrapped: true })

    if (!error) {
      setAuth(data).then(() => {
        sessionStorage.setItem('language', JSON.stringify(data?.language?.code))

        if (isRedirect) {
          window.location.href = '/'
        }

        window.location.reload()
      })
    }
  }

  return (
    <form
      className={style.block}
      onSubmit={handleSubmit}
    >
      <Field
        data={filter.username}
        placeholder={t('email')}
        onChange={(e) => handlePropsChange('username', e)}
        isRequired={true}
      />
      <Password
        data={filter.password}
        placeholder={t('password')}
        onChange={(e) => handlePropsChange('password', e)}
        isRequired={true}
      />
      <Button
        type={'submit'}
        classes={['primary', 'lg']}
        placeholder={t('login')}
        isDisabled={!filter.username || !filter.password}
      />
      {/*<Reference*/}
      {/*  classes={['md', 'outline']}*/}
      {/*  placeholder={t('forgot_password')}*/}
      {/*  onChange={() =>*/}
      {/*    openModal({*/}
      {/*      title: t('forgot_password'),*/}
      {/*      body: <Recovery />*/}
      {/*    })*/}
      {/*  }*/}
      {/*/>*/}
      {/*<hr />*/}
      {/*<p className={style.link}>*/}
      {/*  {t('dont_have_account')}*/}
      {/*  <Reference*/}
      {/*    to={t(NAVIGATION.registration.url)}*/}
      {/*    classes={['md', 'outline']}*/}
      {/*    placeholder={t('create_account')}*/}
      {/*    onChange={closeModal}*/}
      {/*  />*/}
      {/*</p>*/}
    </form>
  )
}

export default Login
